const $ = jQuery.noConflict();

'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domBody: $('body'),
	strCF7Holder: '.js-cf7-holder',
	strForm: '.wpcf7-form',
	strTriggerURL: '#wpcf7-f17-o1',
	classSent: 'form-is-sent',
	classInvalid: 'invalid',
	google_analytics: window.google_analytics_popup,
	conversion: window.conversion,

	/** @description Initialize */
	init: function() {
		this.checkIfIE();
		this.afterFormSubmit();
		this.movePlaceholder();
		this.removeError();
		this.bindEvents();
	},

	bindEvents: function() {
		$('form.wpcf7-form').on('submit', function() {
			const form = $(this);
			const button = form.find('input[type=submit]');
			const currentVal = button.val();
			// store the current value so we can reset it later
			button.attr('data-value', currentVal);
			// disable the button
			button.prop('disabled', true);

		});
		$('.wpcf7').on('wpcf7invalid', function() {
			$('form.wpcf7-form').find('input[type=submit]').prop('disabled', false);
		});
		$('.wpcf7').on('wpcf7mailsent', function() {
			$('form.wpcf7-form').find('input[type=submit]').prop('disabled', false);
		});
	},

	isLoadedScript: (src)=> {
		return document.querySelectorAll('[src="' + src + '"]').length > 0;
	},

	addScript: (src, defer = false, onload = null, reload = false, id = null)=> {
		if(!FormHelpers.isLoadedScript(src) || reload) {
			const script = document.createElement('script');
			script.src = src;
			script.id = id;
			script.type = 'text/javascript';
			if (defer) {
				script.defer = true;
			}
			if (onload) {
				script.onload = onload;
			}
			// document.getElementsByClassName('js-form-popup')[0].appendChild(script);
			document.getElementsByTagName('head')[0].appendChild(script);
		}
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */
	afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent', delay = 5000) => {
		document.addEventListener('wpcf7mailsent', (e) => {
			// const formId = e.detail.id;
			const formId = `#${e.detail.unitTag}`;

			// FormHelpers.$domBody.addClass('overflow-active');
			$(formId).parents(formHolder).addClass(sentClass);
			$('.js-select-form').val('').trigger('change');
			$('.js-form-select-placeholder').css('opacity', '1');

			// add google analytics in popup
			if (FormHelpers.google_analytics) {
				FormHelpers.addScript('https://www.googletagmanager.com/gtag/js?id=' + FormHelpers.google_analytics, false, ()=> {
					window.dataLayer = window.dataLayer || [];
					function gtag() {window.dataLayer.push(arguments);}
					gtag('config', FormHelpers.google_analytics);
					gtag('js', new Date());
				}, true, 'ga4');
			}
			// call conversion implementation
			if (FormHelpers.conversion) {
				window.gtag_report_conversion(window.location.href);
			}

			setTimeout(() => {
				// remove google analytics from popup
				if (FormHelpers.google_analytics) {
					$('head #ga4').remove();
				}
				$(formHolder).removeClass(sentClass);
				// FormHelpers.$domBody.removeClass('overflow-active');
			}, delay);
		}, false);
	},
	// If user use Internet Explorer this is custom trigger for Thank you msg for CF7
	checkIfIE() {
		const url = window.location.href;
		if (url.indexOf(FormHelpers.strTriggerURL) > -1 && !$(FormHelpers.strForm).hasClass(FormHelpers.classInvalid)) {
			$(FormHelpers.strForm).parents(FormHelpers.strCF7Holder).addClass(FormHelpers.classSent);

			setTimeout(() => {
				$(FormHelpers.strCF7Holder).removeClass(FormHelpers.classSent);
			}, 5000);
		}
	},

	movePlaceholder() {
		setTimeout(() => {
			$('.form-input__title').each(function(index, item) {
				$(item).appendTo($(this).siblings('.wpcf7-form-control-wrap'));
			});
		}, 500);
	},

	removeError() {
		$('.wpcf7-textarea').on('keydown', function() {
			if ($('.wpcf7-textarea').val().length > 0) {
				$(this).siblings('.wpcf7-not-valid-tip').remove();
				$(this).removeClass('wpcf7-not-valid');
			}
		});

		$('.wpcf7-textarea').on('paste', function() {
			$(this).siblings('.wpcf7-not-valid-tip').remove();
			$(this).removeClass('wpcf7-not-valid');
		});
	}
};

export default FormHelpers;
